import {Component, HostBinding, OnInit} from '@angular/core';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @HostBinding('style.visibility') visibility = 'hidden';

  error = '';
  loading = false;
  submitted = false;

  inherited;

  constructor() {
    this.close();
  }

  ngOnInit() {
  }

  get() {
    return this.inherited;
  }

  public open(inherited = undefined) {
    this.inherited = inherited;
    this.visibility = 'visible';
  }

  close() {
    this.visibility = 'hidden';
    this.error = '';
    this.loading = false;
    this.submitted = false;
  }
}
